import { render, staticRenderFns } from "./ChatAndShare.vue?vue&type=template&id=b9327348&scoped=true"
import script from "./ChatAndShare.vue?vue&type=script&lang=js"
export * from "./ChatAndShare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9327348",
  null
  
)

export default component.exports